// External libraries
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';

// Internal imports - state
import { store } from 'src/state/dynamic-store';
import { RootState } from '@state/root-state.ts';

// Internal imports - components
import { NumberRangesComponentWrapper } from '@sharedComponents/number-ranges/NumberRangeComponent';
import { CdfBreadcrumbs } from '@commonComponents/navigation/CdfBreadcrumbs';

// Styles
import styles from './NumberRangesPage.module.scss';

export function NumberRangesPage() {
  const { t } = useTranslation(['layouts']);
  const organizationId = useSelector((state: RootState) => state.appContext.selectedOrganizationId ?? '');

  return (
    <>
      <CdfBreadcrumbs items={[{ label: t('breadCrumbs.numberRanges.page') }]} />
      <Paper className={styles.container}>
        <NumberRangesComponentWrapper organizationId={organizationId} store={store}></NumberRangesComponentWrapper>
      </Paper>
    </>
  );
}
